module.exports = __webpack_public_path__ + "static/media/Asics_Logo.svg-2.cf900099.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/pdf/templates/vlp/images/Asics_Logo.svg-2.png
// module id = 282
// module chunks = 10